import React, { useContext } from 'react';

import { Col, Divider, Row, Spin } from 'antd';

import IntlMessages from 'util/IntlMessages';
import GlosaryAbreviations from '../shared/GlosaryAbreviations';
import { useIsMobile } from 'packages/utils';
import ReportTable from '../../ReportTable';
import GlosaryColors from '../shared/GlosaryColors';
import InfiniteScroll from 'react-infinite-scroll-component';
import { mapHolidaysReportData } from '../shared/mapReportData';
import styles from '../../styles.module.less';
import EmptyUserData from '../shared/EmptyUserData';

export default function AttendanceReport({
  data,
  loading = false,
  next = null,
  queriedPeriod = '',
}) {
  const { isMobile } = useIsMobile();
  if (Object.keys(data).length === 0) return null;
  return (
    <>
      <div className="gx-w-100">
        <div className={styles.titleDt}>
          <IntlMessages id="work.direction.attendance.report" />
        </div>
      </div>
      <Divider />
      <Row className="gx-mb-3" gutter={[8, 8]} align="top">
        <Col xs={24} sm={15} md={15} lg={15} xl={15}>
          <GlosaryAbreviations />
        </Col>
        <Col push={isMobile ? 0 : 1} xs={24} sm={8} md={8} lg={8} xl={8}>
          <GlosaryColors />
        </Col>
      </Row>
      {loading && <Spin />}
      <div id="scrollableDiv" className={styles.scrollableDiv}>
        <InfiniteScroll
          dataLength={data?.total ?? 0}
          scrollableTarget="scrollableDiv"
          next={next}
          hasMore={data?.hasMore}
        >
          <div className="gx-pt-4">
            {Object.keys(data?.data || {})?.length === 0 && !loading && (
              <EmptyUserData queriedPeriod={queriedPeriod} />
            )}
            {mapHolidaysReportData(data.data, ({ id, employee, employer, columns, source }) => (
              <React.Fragment key={id}>
                <ReportTable
                  rowKey="id"
                  data={source}
                  headerOne={employee}
                  headerTwo={employer}
                  columns={columns}
                  disableScroll={true}
                />
              </React.Fragment>
            ))}
          </div>
        </InfiniteScroll>
      </div>
    </>
  );
}
